export default "__VITE_ASSET__106bca78__"